import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import {
  getAllMyCv,
  userName_from_db,
  getProfile,
  clearStoredValue,
  clearPS,
  resume_step_jump_function,
  secret_loading,
  personal_loading,
  Dashboard_only,
  existing_resume_loading,
  getting_cv_details_loading
} from "../../Redux/ActionCreator";

//import language context
import MoilUserDashboard from "./moil_user_dashboard";
import HelmetProvide from "../common/helmet/index";
import { useAnalytics } from "../../context/AnalyticsContext";
import { createPortal } from "react-dom";
import UploadResumeModal from "../common/upload_resume_modal/Index";
import { ToastContainer, toast } from "react-toastify";

const UserDashboard = () => {
  const analytics = useAnalytics();
  const [modalOpen, setModalOPen] = useState(false);
  const profileStatus = useSelector((prev) => prev.login);
  const [name, setName] = useState("");
  const [profileBool, setProfileBool] = useState(null);
  const navigate = useNavigate();
  const userName = useSelector((prev) => prev.userInfo);
  const my_name = userName.user;
  const profile = useSelector((prev) => prev.profile);
  const token = localStorage.getItem("token"); /* new URLSearchParams(window.location.search).get("token"); */
  const profile_stat = new URLSearchParams(window.location.search).get(
    "profile_status"
  );
  const acctType = new URLSearchParams(window.location.search).get("AcctType");
  const myCvs = useSelector((prev) => prev.saved_cv);
  const dashboard_count = useSelector((state) => state.dashboardOnly.message);
  const [func_call, setFuncCalled] = useState(false);
  const width = window.innerWidth;
  // initialize useSelector and useDispatch
  const dispatch = useDispatch();
  // console.log("token", token);
  // console.log("profile status", profile_stat);
  const upload_status = useSelector((prev) => prev.existingCV);

  useEffect(() => {
    if (profile.message === null) {
      if (my_name !== null) {
        setName(my_name.name);
      }
    } else {
      if (profile?.message !== null) {
        const my_name = profile.message?.FirstName // ?.split(" ")[0].toLowerCase();
        // let f_name = my_name?.charAt(0).toUpperCase() + my_name?.slice(1, my_name?.length);
        setName(my_name);
      }
    }
  }, [profile.message, my_name])

  // called an authenticate function to verify user that logged in with linkedin and google;
  useEffect(() => {
    dispatch(Dashboard_only(1));
    dispatch(personal_loading(true));
    dispatch(resume_step_jump_function(0));
    dispatch(existing_resume_loading());
    dispatch(secret_loading());
    localStorage.removeItem("fullname");
    localStorage.removeItem("jobTitle");
    localStorage.removeItem("Email");
    localStorage.removeItem("Address");
    localStorage.removeItem("When_school_start_year");
    localStorage.removeItem("Phone_number");
    localStorage.removeItem("Degree");
    localStorage.removeItem("Website");
    localStorage.removeItem("School_name");
    localStorage.removeItem("Linkedin");
    localStorage.removeItem("When_school_end_year");
    localStorage.removeItem("When_school_start_month");
    localStorage.removeItem("When_school_end_month");
    localStorage.removeItem("Course");

    dispatch(clearStoredValue());
    dispatch(clearPS());
    dispatch(getProfile(token));

    // const token = localStorage.getItem("token");
    if (token !== null) {
      dispatch(userName_from_db(token));
      dispatch(getAllMyCv(token));
      dispatch(getProfile(token));
    } else {
      // console.log("frustrated")
      if (profile_stat !== "false" && profile_stat !== false) {
        if (profile.message === null || profile.message === undefined) {
          dispatch(getProfile(token));
        }
      }
    }
  }, []);

  setTimeout(() => {
    if (my_name?.signed_in <= 1 && dashboard_count <= 1) {
      driverObj.drive();
      // console.log("Driver has been called, we did hooray!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
    }
  }, 2000);

  useEffect(() => {
    // const token = localStorage.getItem("token");
    if (userName.user === null) {
      dispatch(userName_from_db(token));
    }
    if (profileStatus.profile_status.profile_status === "false" || profileStatus.profile_status.profile_status === false) {
      setProfileBool(false);
    } else if (profileStatus.profile_status.profile_status === "true" || profileStatus.profile_status.profile_status === true) {
      setProfileBool(true);
    }
  }, [profileStatus.profile_status]);

  const driverObj = width >= 768 ? driver({
    showProgress: true,
    popoverClass: 'driverjs-theme notranslate',
    steps: [
      {
        element: '#translate-btn-dashboard-design',
        popover: {
          title: 'Translate Button',
          description: 'This is the translate button that allows translation from spanish to English.',
          side: "bottom",
          align: 'start'
        }
      },
      {
        element: '#notification-bell',
        popover: {
          title: 'Notifications',
          description: 'Here you can see all your notifications.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#dashboard-nav',
        popover: {
          title: 'Dashboard',
          description: 'Navigate to your dashboard from here.',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#profile-nav',
        popover: {
          title: 'Profile',
          description: 'Access and edit your profile here.',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#resume-nav',
        popover: {
          title: 'Resume',
          description: 'Manage your resume here',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#jobs-nav',
        popover: {
          title: 'Jobs',
          description: 'Browse and check application status of jobs applied for',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#message-nav',
        popover: {
          title: 'Messages',
          description: 'Check your messages here.',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#logout-nav',
        popover: {
          title: 'Logout',
          description: 'Click here to logout from your account.',
          side: 'right',
          align: 'start',
        },
      },
      {
        element: '#create-profile',
        popover: {
          title: 'Create Profile',
          description: 'Click here to create a new profile.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#upload-resume',
        popover: {
          title: 'Upload Resume',
          description: 'Click here to upload your resume.',
          side: 'bottom',
          align: 'start',
        },
      },
    ],
  }) : driver({
    showProgress: true,
    steps: [
      {
        element: '#translate-btn-dashboard-design',
        popover: {
          title: 'Translate Button',
          description: 'This is the translate button that allows translation from spanish to English.',
          side: "bottom",
          align: 'start'
        }
      },
      {
        element: '#notification-bell',
        popover: {
          title: 'Notifications',
          description: 'Here you can see all your notifications.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#create-profile',
        popover: {
          title: 'Create Profile',
          description: 'Click here to create a new profile.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#upload-resume',
        popover: {
          title: 'Upload Resume',
          description: 'Click here to upload your resume.',
          side: 'bottom',
          align: 'start',
        },
      },
    ],
  });



  const handleGenerateCv = () => {
    if (userName.user !== null) {
      analytics.track("Dashboard Get Started btn (first timer)", {
        Type: "Employee",
        time: new Date(),
        Email: userName.user?.email,
        userId: userName.user?._id
      });
    }
    navigate("/user/createProfile");
  }

  const handleClickUploadResume = () => {
    // console.log("clicked");
    if (upload_status.message !== null) {
      dispatch(existing_resume_loading(true));
      // dispatch(getting_cv_details_loading(true));
    }
    dispatch(getting_cv_details_loading(true));
    setModalOPen(true);
    // console.log("modalOpen", modalOpen)
  }
  console.log("modalOpen", modalOpen)

  const modalHandle = modalOpen ? <UploadResumeModal handleClose={() => setModalOPen(false)} setModalOPen={setModalOPen} /> : null

  return (
    <>
      <HelmetProvide
        title="Moil | Dashboard"
        description="Explore your user dashboard on Moil. Manage your profile, view job opportunities, and connect with recruiters in your field."
        className="notranslate"
        notranslate
      />
      {profileBool === false || profileBool === null ? (
        <main className="md:UserDashboard col-start-1 md:col-start-2 col-end-3 row-start-2 row-end-3 px-4 flex justify-center lg:flex-row h-calc-150 md:h-calc-70 overflow-x-hidden md:overflow-y-scroll bg-[#FAFAFA] pt-10 sm:pt-10">
          <div className="w-full pr-4 lg:px-0 max-w-[900px] xtraxl:max-w-calculate mx-auto flex flex-col gap-y-6">
            <div className="flex flex-col gap-1">
              <p class="font-sans text-base md:text-2xl lg:text-3xl font-semibold leading-tight text-left flex items-center gap-3">
                Welcome to
                <img
                  src="https://res.cloudinary.com/drlcisipo/image/upload/v1705704261/Website%20images/logo_gox0fw.png"
                  alt="Moil Logo"
                  className="w-[50px] lg:w-[70px] lg:h-[35px]"
                />
              </p>
              <p class="font-sans text-base font-normal leading-6 text-left">
                You are a few clicks away from landing your first job.
              </p>
            </div>
            <div className="bg-dashboard-gradient w-full p-8 pr-12 xllarge:pr-16  rounded-lg relative">
              <div className="flex flex-col gap-y-4">
                <p class="text-[32px] lg:text-5xl font-semibold leading-tight text-white">
                  What’s Next?
                </p>
                <p class="text-[20px] lg:text-xl font-semibold leading-relaxed text-white md:max-w-full max-w-[220px]">
                  Create a your professional profile
                </p>
                <p class="text-base font-normal leading-6 text-white max-w-[400px] lg:max-w-[490px]">
                  A professional profile gives you visibility to employers and
                  recruiters on Moil. Complete your profile in quick, easy steps.
                </p>
                <div className="w-max relative">
                  <button id="create-profile" class="w-max px-5 py-3 gap-3 rounded-lg text-white text-base font-medium text-center bg-[#FF6633] animate-none transition-all duration-300 ease-out" onClick={() => navigate("/create-profile")}>{/*  /form?create profile=m */}
                    Build from Scratch
                  </button>

                  <svg width="99" className="absolute top-0 left-[100%] md:left-[110%]" height="127" viewBox="0 0 99 127" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.994 49.5634L7.93268 42.8828L4.8201 52.5224L14.4549 51.233L14.994 49.5634ZM78.9017 41.9207L78.2074 41.3844L78.9017 41.9207ZM51.5861 120.531L58.8792 113.502L49.1447 110.7L51.5861 120.531ZM9.12151 49.5107C9.5853 49.6508 10.0749 49.3884 10.215 48.9246C10.3551 48.4608 10.0927 47.9712 9.62888 47.8311L9.12151 49.5107ZM15.6662 49.4242C15.1939 49.3166 14.7236 49.6122 14.616 50.0846C14.5083 50.557 14.8039 51.0272 15.2763 51.1349L15.6662 49.4242ZM21.5195 52.3529C21.9976 52.4312 22.4487 52.107 22.5269 51.6289C22.6052 51.1507 22.281 50.6997 21.8029 50.6215L21.5195 52.3529ZM28.0032 51.4533C27.5214 51.4024 27.0896 51.7518 27.0388 52.2337C26.988 52.7155 27.3374 53.1473 27.8192 53.1981L28.0032 51.4533ZM34.1553 53.6907C34.6392 53.7151 35.0512 53.3426 35.0756 52.8587C35.1 52.3748 34.7275 51.9628 34.2436 51.9384L34.1553 53.6907ZM40.5012 52.0832C40.0167 52.0853 39.6256 52.4797 39.6276 52.9642C39.6297 53.4486 40.0241 53.8397 40.5086 53.8377L40.5012 52.0832ZM46.8577 53.6321C47.3413 53.6025 47.7093 53.1865 47.6797 52.7029C47.6501 52.2193 47.2341 51.8513 46.7505 51.8809L46.8577 53.6321ZM52.9803 51.3069C52.4996 51.3668 52.1584 51.8051 52.2183 52.2859C52.2782 52.7666 52.7165 53.1078 53.1973 53.0479L52.9803 51.3069ZM59.4805 52.0356C59.9555 51.9403 60.2633 51.4779 60.168 51.0029C60.0727 50.5279 59.6103 50.2201 59.1353 50.3154L59.4805 52.0356ZM65.1749 48.815C64.7112 48.9554 64.4491 49.4451 64.5895 49.9088C64.7299 50.3725 65.2197 50.6346 65.6834 50.4942L65.1749 48.815ZM71.6953 48.2355C72.1346 48.0311 72.325 47.5093 72.1206 47.07C71.9162 46.6308 71.3944 46.4404 70.9551 46.6448L71.6953 48.2355ZM76.1409 43.4833C75.7672 43.7917 75.7143 44.3446 76.0227 44.7183C76.3311 45.092 76.884 45.1449 77.2577 44.8365L76.1409 43.4833ZM81.2776 39.5107C81.4655 39.0641 81.2557 38.5498 80.8092 38.3619C80.3626 38.174 79.8483 38.3838 79.6604 38.8303L81.2776 39.5107ZM81.0677 32.9121C81.0191 33.3941 81.3705 33.8243 81.8525 33.8728C82.3346 33.9214 82.7647 33.57 82.8133 33.0879L81.0677 32.9121ZM82.8094 26.57C82.7638 26.0876 82.3359 25.7335 81.8536 25.7791C81.3712 25.8246 81.0171 26.2525 81.0626 26.7349L82.8094 26.57ZM79.9429 20.6354C80.0719 21.1024 80.5551 21.3763 81.0221 21.2473C81.4891 21.1182 81.7631 20.6351 81.634 20.1681L79.9429 20.6354ZM79.3054 14.0733C79.0874 13.6406 78.5599 13.4667 78.1272 13.6847C77.6946 13.9028 77.5206 14.4303 77.7387 14.8629L79.3054 14.0733ZM74.3426 9.77544C74.6636 10.1383 75.2181 10.1722 75.5809 9.85121C75.9438 9.53018 75.9777 8.97578 75.6567 8.61291L74.3426 9.77544ZM70.4992 4.44493C70.0737 4.2133 69.5409 4.37049 69.3093 4.79602C69.0777 5.22155 69.2349 5.75429 69.6604 5.98592L70.4992 4.44493ZM63.9564 4.21607C64.4381 4.26738 64.8703 3.91843 64.9216 3.43666C64.9729 2.9549 64.624 2.52275 64.1422 2.47144L63.9564 4.21607ZM57.552 2.88774C57.0787 2.99108 56.7787 3.45857 56.8821 3.93191C56.9854 4.40525 57.4529 4.7052 57.9263 4.60185L57.552 2.88774ZM52.089 6.61414C52.5288 6.41073 52.7203 5.88937 52.5169 5.44965C52.3135 5.00993 51.7921 4.81836 51.3524 5.02177L52.089 6.61414ZM45.8508 8.16987C45.4585 8.4542 45.371 9.0027 45.6553 9.39499C45.9396 9.78728 46.4881 9.8748 46.8804 9.59047L45.8508 8.16987ZM42.8443 13.5835C43.1236 13.1876 43.0292 12.6403 42.6333 12.3609C42.2374 12.0816 41.6901 12.1761 41.4108 12.572L42.8443 13.5835ZM38.8733 18.3086C38.7657 18.781 39.0614 19.2512 39.5338 19.3588C40.0062 19.4664 40.4763 19.1707 40.5839 18.6983L38.8733 18.3086ZM40.183 24.3914C40.1552 23.9077 39.7405 23.5381 39.2569 23.5659C38.7732 23.5937 38.4036 24.0084 38.4314 24.4921L40.183 24.3914ZM39.2986 30.5327C39.4003 31.0064 39.8668 31.308 40.3405 31.2063C40.8142 31.1046 41.1157 30.6382 41.014 30.1645L39.2986 30.5327ZM42.5069 35.8837C42.3684 35.4194 41.8798 35.1553 41.4155 35.2938C40.9512 35.4323 40.6871 35.9209 40.8256 36.3852L42.5069 35.8837ZM42.6652 42.1181C42.8202 42.5771 43.318 42.8235 43.777 42.6685C44.236 42.5134 44.4824 42.0156 44.3274 41.5566L42.6652 42.1181ZM46.273 47.1945C46.1135 46.737 45.6134 46.4954 45.1559 46.6548C44.6984 46.8143 44.4568 47.3144 44.6163 47.7719L46.273 47.1945ZM46.5661 53.4166C46.7219 53.8753 47.2201 54.121 47.6788 53.9652C48.1376 53.8094 48.3832 53.3112 48.2275 52.8525L46.5661 53.4166ZM50.1018 58.5534C49.9558 58.0914 49.463 57.8353 49.001 57.9812C48.539 58.1272 48.2828 58.62 48.4288 59.082L50.1018 58.5534ZM50.1353 64.7824C50.2665 65.2488 50.7509 65.5206 51.2173 65.3894C51.6837 65.2583 51.9555 64.7738 51.8243 64.3074L50.1353 64.7824ZM53.3376 70.1263C53.2256 69.655 52.7526 69.3637 52.2813 69.4757C51.8099 69.5878 51.5186 70.0607 51.6307 70.5321L53.3376 70.1263ZM52.8685 76.3477C52.9576 76.8239 53.4159 77.1378 53.8921 77.0487C54.3683 76.9597 54.6822 76.5014 54.5931 76.0252L52.8685 76.3477ZM55.5396 81.9671C55.4768 81.4867 55.0364 81.1482 54.556 81.211C54.0756 81.2739 53.7371 81.7143 53.7999 82.1947L55.5396 81.9671ZM54.3933 88.0882C54.4271 88.5715 54.8463 88.9359 55.3296 88.9021C55.8129 88.8683 56.1773 88.4491 56.1435 87.9658L54.3933 88.0882ZM56.3725 94.0012C56.3698 93.5167 55.9749 93.1261 55.4905 93.1287C55.006 93.1314 54.6154 93.5263 54.618 94.0108L56.3725 94.0012ZM54.4529 99.9312C54.4231 100.415 54.791 100.831 55.2746 100.861C55.7581 100.891 56.1743 100.523 56.2041 100.039L54.4529 99.9312ZM55.6292 106.039C55.6918 105.559 55.3531 105.119 54.8726 105.056C54.3922 104.993 53.952 105.332 53.8894 105.813L55.6292 106.039ZM52.9265 111.646C52.8315 112.121 53.1396 112.583 53.6146 112.678C54.0897 112.773 54.5519 112.465 54.6469 111.99L52.9265 111.646ZM53.267 117.862C53.3934 117.394 53.1166 116.912 52.6489 116.786C52.1812 116.66 51.6996 116.936 51.5732 117.404L53.267 117.862ZM15.2763 51.1349C17.334 51.6039 19.4197 52.0092 21.5195 52.3529L21.8029 50.6215C19.7372 50.2834 17.6871 49.8849 15.6662 49.4242L15.2763 51.1349ZM27.8192 53.1981C29.9345 53.4212 32.0511 53.5847 34.1553 53.6907L34.2436 51.9384C32.1708 51.834 30.0862 51.6729 28.0032 51.4533L27.8192 53.1981ZM40.5086 53.8377C42.6577 53.8286 44.7792 53.7593 46.8577 53.6321L46.7505 51.8809C44.7058 52.006 42.6176 52.0742 40.5012 52.0832L40.5086 53.8377ZM53.1973 53.0479C55.3687 52.7773 57.47 52.439 59.4805 52.0356L59.1353 50.3154C57.1702 50.7097 55.1118 51.0413 52.9803 51.3069L53.1973 53.0479ZM65.6834 50.4942C67.8626 49.8343 69.8798 49.0803 71.6953 48.2355L70.9551 46.6448C69.2265 47.4491 67.2885 48.1749 65.1749 48.815L65.6834 50.4942ZM77.2577 44.8365C78.1591 44.0925 78.945 43.2995 79.5959 42.457L78.2074 41.3844C77.6481 42.1084 76.9575 42.8094 76.1409 43.4833L77.2577 44.8365ZM79.5959 42.457C80.2588 41.5989 80.8176 40.604 81.2776 39.5107L79.6604 38.8303C79.2488 39.8086 78.7622 40.6663 78.2074 41.3844L79.5959 42.457ZM82.8133 33.0879C83.022 31.0166 83.0209 28.8105 82.8094 26.57L81.0626 26.7349C81.2643 28.8709 81.2641 30.9626 81.0677 32.9121L82.8133 33.0879ZM81.634 20.1681C81.0524 18.0632 80.2779 16.0028 79.3054 14.0733L77.7387 14.8629C78.6544 16.6799 79.3891 18.631 79.9429 20.6354L81.634 20.1681ZM75.6567 8.61291C74.1762 6.93943 72.459 5.51172 70.4992 4.44493L69.6604 5.98592C71.4194 6.94337 72.98 8.23518 74.3426 9.77544L75.6567 8.61291ZM64.1422 2.47144C62.0991 2.25384 59.9016 2.37476 57.552 2.88774L57.9263 4.60185C60.1077 4.1256 62.1157 4.02003 63.9564 4.21607L64.1422 2.47144ZM51.3524 5.02177C50.4077 5.45878 49.4429 5.95329 48.4578 6.5079L49.3186 8.03673C50.2654 7.50364 51.1889 7.03054 52.089 6.61414L51.3524 5.02177ZM48.4578 6.5079C47.5158 7.03828 46.6479 7.59212 45.8508 8.16987L46.8804 9.59047C47.6191 9.05512 48.43 8.53701 49.3186 8.03673L48.4578 6.5079ZM41.4108 12.572C40.1596 14.3451 39.3397 16.2609 38.8733 18.3086L40.5839 18.6983C41.0026 16.8604 41.7331 15.1583 42.8443 13.5835L41.4108 12.572ZM38.4314 24.4921C38.5423 26.4209 38.8485 28.4361 39.2986 30.5327L41.014 30.1645C40.5775 28.131 40.2874 26.2079 40.183 24.3914L38.4314 24.4921ZM40.8256 36.3852C41.3777 38.2358 41.9996 40.1476 42.6652 42.1181L44.3274 41.5566C43.6655 39.597 43.0507 37.7067 42.5069 35.8837L40.8256 36.3852ZM44.6163 47.7719C45.2558 49.6069 45.9111 51.4875 46.5661 53.4166L48.2275 52.8525C47.5699 50.9157 46.9123 49.0286 46.273 47.1945L44.6163 47.7719ZM48.4288 59.082C49.0165 60.9423 49.5898 62.8424 50.1353 64.7824L51.8243 64.3074C51.2729 62.3466 50.6941 60.4284 50.1018 58.5534L48.4288 59.082ZM51.6307 70.5321C52.0831 72.4354 52.4994 74.3739 52.8685 76.3477L54.5931 76.0252C54.2184 74.0211 53.796 72.0548 53.3376 70.1263L51.6307 70.5321ZM53.7999 82.1947C54.0528 84.1277 54.2537 86.0922 54.3933 88.0882L56.1435 87.9658C56.0013 85.9328 55.7967 83.9332 55.5396 81.9671L53.7999 82.1947ZM54.618 94.0108C54.6287 95.956 54.5763 97.9295 54.4529 99.9312L56.2041 100.039C56.3299 97.9971 56.3833 95.9844 56.3725 94.0012L54.618 94.0108ZM53.8894 105.813C53.6392 107.732 53.3204 109.676 52.9265 111.646L54.6469 111.99C55.0487 109.981 55.3739 107.998 55.6292 106.039L53.8894 105.813Z" fill="#D7D7D7" />
                    <path d="M67.5703 42.2579C67.5703 40.2449 67.3503 26.5047 67.3503 26.5047C67.3503 25.4104 67.3205 25.2083 67.722 25.5115C68.1234 25.8148 68.5188 26.9685 71.3674 27.7357C73.4993 28.3095 76.1754 27.4354 76.8653 26.133C77.1715 25.5561 77.2251 24.3638 76.229 23.9208C75.2745 23.4956 73.3536 23.451 71.748 22.2348C69.7825 20.7451 69.7082 19.5082 68.4475 17.2067C67.4395 15.3691 64.9745 13.9508 64.4452 12.9339C64.0616 12.1965 64.0795 11.2539 64.1181 10.3054C64.133 9.94262 63.8951 9.61852 63.5413 9.52932C62.6968 9.3182 60.9306 8.99707 57.981 8.99707C55.067 8.99707 53.3097 9.30928 52.4533 9.5204C52.0876 9.6096 51.8408 9.95154 51.8765 10.3262C51.9716 11.3253 52.1025 12.3927 51.8111 13.151C51.4097 14.1946 50.0835 15.6427 49.0012 17.4684C46.4708 21.7412 46.7533 26.2341 46.9674 28.8091C47.1339 30.8013 48.3708 33.3049 50.0092 33.6766C50.8477 33.8669 51.4364 33.6528 52.049 33.1444C52.1917 33.0254 52.4087 33.1295 52.4652 33.3049C52.712 34.0661 53.2294 35.2377 54.7875 35.3417C56.0601 35.428 56.5983 34.6816 57.0473 34.2772C57.1811 34.1553 57.3238 34.2564 57.3803 34.4289C57.6271 35.1574 58.54 36.4211 59.9286 36.3765C61.5372 36.3259 62.1378 34.4348 62.4263 34.2029C62.7147 33.9739 62.8455 35.1247 62.8574 35.2971C62.8574 35.2971 63.2083 39.7513 63.5235 41.6692C63.8208 43.486 64.3025 45.1808 66.0657 44.8716C66.818 44.7408 67.5703 44.271 67.5703 42.2579Z" fill="#FFCA28" />
                    <path d="M61.8535 31.3906C61.8535 31.3906 61.5622 32.2113 60.123 32.2796C58.7374 32.3451 58.2378 31.2271 57.5361 31.1051C56.5816 30.9386 56.4687 31.6195 55.1425 31.5482C53.8699 31.4798 53.6201 30.6205 52.7221 30.4986C52.1482 30.4183 51.6428 31.0367 50.2601 30.9267C49.6862 30.8821 48.0895 30.341 47.6138 29.2765C47.4383 28.881 46.8258 28.4618 47.2064 30.0912C47.4978 31.3371 48.476 33.2995 49.9717 33.6682L50.0133 33.6772C50.8518 33.8675 51.4406 33.6534 52.0531 33.1449C52.1958 33.026 52.4129 33.13 52.4694 33.3055C52.7162 34.0667 53.2336 35.2382 54.7916 35.3423C56.0643 35.4285 56.6025 34.6822 57.0514 34.2778C57.1852 34.1559 57.328 34.257 57.3845 34.4294C57.6313 35.1579 58.5441 36.4216 59.9327 36.377C61.5413 36.3265 62.1479 35.1014 62.4304 34.2064C62.4542 34.144 62.1836 31.7771 61.8535 31.3906Z" fill="#FFB300" />
                    <path d="M67.9359 25.7464C67.9359 25.7464 66.6365 23.8642 66.6365 25.0536C66.6365 25.7196 67.1806 41.4848 67.0171 42.8853C66.809 44.6604 65.4947 44.9042 65.4947 44.9042C65.4947 44.9042 67.5404 45.2313 67.9448 42.7336C68.2451 40.8723 67.8318 27.5096 67.9359 25.7464ZM56.6012 31.5892C56.5476 30.8726 56.732 30.5723 57.1334 30.4979C57.5348 30.4236 57.6954 30.8577 57.7013 31.6724C57.7162 33.9501 56.955 34.9878 55.4802 35.2762C55.4802 35.2733 56.8182 34.524 56.6012 31.5892ZM51.5077 30.8904C51.4541 30.1738 51.7277 29.8794 52.1291 29.8021C52.5305 29.7248 52.7654 30.3225 52.7535 31.1372C52.7119 33.6141 51.4125 33.849 50.125 33.736C50.122 33.7419 51.7247 33.8282 51.5077 30.8904ZM61.4716 32.0203C61.4479 31.3721 61.6887 31.0034 62.1555 30.9529C62.6224 30.9023 62.7443 31.4048 62.777 31.8865C62.9554 34.5418 61.8552 36.2337 60.2287 36.3497C60.2287 36.3497 61.6025 35.3981 61.4716 32.0203ZM64.4421 12.9338C64.0585 12.1964 64.0764 11.2538 64.115 10.3053C64.1269 10.0496 64.008 9.81469 63.8177 9.66602C63.8177 9.66602 62.9851 11.7236 63.6541 13.3442C63.9842 14.15 64.6324 14.6911 65.3312 15.3929C66.2648 16.3354 67.365 16.4514 68.489 19.297C69.0599 20.745 69.6456 21.6995 70.8291 22.7581C72.2355 24.0188 74.2693 24.328 75.1227 24.2715C75.765 24.2299 76.6719 24.1169 76.2288 23.9207C75.2743 23.4955 73.3535 23.4509 71.7478 22.2347C69.7824 20.745 69.711 19.5081 68.4473 17.2037C67.4393 15.3661 64.9744 13.9507 64.4421 12.9338Z" fill="#EDA600" />
                    <path d="M18.288 29.112C17.2533 29.112 16.3093 28.872 15.456 28.392C14.6027 27.9013 13.9253 27.224 13.424 26.36C12.9333 25.4853 12.688 24.504 12.688 23.416C12.688 22.328 12.9333 21.352 13.424 20.488C13.9253 19.6133 14.6027 18.936 15.456 18.456C16.3093 17.9653 17.2533 17.72 18.288 17.72C19.3333 17.72 20.2827 17.9653 21.136 18.456C21.9893 18.936 22.6613 19.608 23.152 20.472C23.6427 21.336 23.888 22.3173 23.888 23.416C23.888 24.5147 23.6427 25.496 23.152 26.36C22.6613 27.224 21.9893 27.9013 21.136 28.392C20.2827 28.872 19.3333 29.112 18.288 29.112ZM18.288 27.848C19.0667 27.848 19.7653 27.6667 20.384 27.304C21.0133 26.9413 21.504 26.424 21.856 25.752C22.2187 25.08 22.4 24.3013 22.4 23.416C22.4 22.52 22.2187 21.7413 21.856 21.08C21.504 20.408 21.0187 19.8907 20.4 19.528C19.7813 19.1653 19.0773 18.984 18.288 18.984C17.4987 18.984 16.7947 19.1653 16.176 19.528C15.5573 19.8907 15.0667 20.408 14.704 21.08C14.352 21.7413 14.176 22.52 14.176 23.416C14.176 24.3013 14.352 25.08 14.704 25.752C15.0667 26.424 15.5573 26.9413 16.176 27.304C16.8053 27.6667 17.5093 27.848 18.288 27.848ZM27.2661 21.656C27.5221 21.1547 27.8848 20.7653 28.3541 20.488C28.8341 20.2107 29.4155 20.072 30.0981 20.072V21.576H29.7141C28.0821 21.576 27.2661 22.4613 27.2661 24.232V29H25.8101V20.232H27.2661V21.656Z" fill="white" />
                  </svg>

                </div>


              </div>

              {/* dashboard welcome image */}
              <div className="absolute top-[30px]  md:top-[50%] md:translate-y-[-50%] right-[-60px] w-[160px] md:w-[250px] lg:w-max">
                <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1716939511/Dashboard/welcome_page_qp0gq3.png" />
              </div>
            </div>
            <div className="flex flex-col md:flex-row self-center items-center pb-10 gap-x-16 gap-y-8 justify-between max-w-[800px]">
              <div>
                <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1716942064/Dashboard/resume_dashboard_b8kasc.png" />
              </div>
              <div className="flex flex-col gap-y-5">
                <p class="text-xl font-semibold leading-7">
                  Upload an existing resume
                  <br />to create a profile.
                </p>

                <p class="text-base font-normal leading-tight text-[#797979]">
                  Our AI will extract your data from the resume and <br />automatically create your Moil profile.
                </p>
                <button id="upload-resume" onClick={handleClickUploadResume} class="bg-dashboard-gradient max-w-[170px] px-5 py-3 gap-3 rounded-lg text-base font-semibold leading-6 text-white text-center">
                  Upload Resume
                </button>
              </div>
            </div>
          </div>

          <div>
            {modalHandle}
            <ToastContainer />
          </div>
        </main >
      ) : (
        <>
          <MoilUserDashboard name={name} />
          <div>
            {modalHandle}
            <ToastContainer />
          </div>
        </>
      )}

    </>
  );
};

export default UserDashboard;
